import { useState, useCallback } from 'react';

export const DEFAULT_PREFS = {
  agencyName:      'Ucreative Inc.',
  agencyEmail:     '',
  agencyPhone:     '',
  agencyWebsite:   'ucreative.ca',
  agencyCity:      'Montréal, QC',
  agencyTagline:   'Agence web & marketing digital — Montréal',
  defaultLocation: 'Montréal, QC',
  defaultMaxScore: 100,
  resultCount:     20,
  autoDetectTech:  false,
  senderName:      'Ucreative Inc.',
  emailFooter:     '',
  accentColor:     '#C8FF00',
  pitchLang:       'fr-qc',
  pitchTone:       'professional',
  pipelineStages: [
    { value: 'à_contacter', label: '📋 À contacter', color: '#888'    },
    { value: 'contacté',    label: '📬 Contacté',    color: '#63b3ed' },
    { value: 'proposition', label: '💼 Proposition',  color: '#fbbf24' },
    { value: 'signé',       label: '✅ Signé',         color: '#4ade80' },
    { value: 'refusé',      label: '❌ Refusé',        color: '#f87171' },
  ],
};

function load() {
  try {
    const raw = localStorage.getItem('ucreative_prefs');
    if (!raw) return DEFAULT_PREFS;
    return { ...DEFAULT_PREFS, ...JSON.parse(raw) };
  } catch { return DEFAULT_PREFS; }
}

export function usePrefs() {
  const [prefs, setPrefs] = useState(load);

  const save = useCallback((updates) => {
    setPrefs(prev => {
      const next = { ...prev, ...updates };
      localStorage.setItem('ucreative_prefs', JSON.stringify(next));
      return next;
    });
  }, []);

  const reset = useCallback(() => {
    localStorage.removeItem('ucreative_prefs');
    setPrefs(DEFAULT_PREFS);
  }, []);

  return { prefs, save, reset };
}
